<template>
  <div class="content-builder">
    <div class="form-group">
      <label class="control-label" for="question_text">Question Text</label>
      <QuillEditor v-model:content="content.question.text" :contentType="'html'" :modules="editorModules"
                   :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>
    <div class="form-group">
      <label class="control-label" for="question-text-classes">Question Text CSS Classes</label>
      <input id="question-text-classes" v-model="content.questionTextClasses" class="form-control" type="text">
    </div>
    <div class="form-group">
      <label class="control-label" for="user-input-classes">User Input CSS Classes</label>
      <input id="user-input-classes" v-model="content.userInputClasses" class="form-control" type="text">
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {defaultMeters} from '../../../common/metrics'
import layoutMixin from '../../mixins/layout'
import {EDITOR_CONFIG_BUTTONS_FULL} from '../../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  components: {QuillEditor},
  mixins: [layoutMixin],
  data() {
    const content = _.cloneDeep(this.source)
    const filled = _.defaults(content, {
      question: {
        text: '',
        responses: [],
        questionTextClasses: '',
        userInputClasses: ''
      }
    })

    if (!_.get(filled.question, 'userInputClasses')) {
      filled.question.userInputClasses = ''
    }

    return {
      content: filled,
      toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL,
    }
  },
  methods: {
    setContent() {
      console.log('Question::setContent')
    },
    getValue() {
      return this.content
    }
  }
}
</script>
